export enum notificationsActionTypes {
    ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR',
    REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'
}
